import { Button, IconButton, TableContainer, Table, TableHead, TableRow, TableBody, Paper, TableCell, Typography } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { DialogMessage } from "../../../global/DialogMessage"
import { ToastMessage } from "../../../global/ToastMessage"
import FCotizacion from "./FCotizacion"
import { useDispatch, useSelector } from "react-redux"
import { formatDinero } from "../../../utils/formatDinero"
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { addItemsAction, aplicarCambioPaqueteAction, obtenerPenalizacionAction, resetPenalizacionAction } from "../../../ducks/cambioPaqueteDuck"
import { accionTargetAction, obtnerViajeRefenciaAction, obtenerCotizacionAction } from "../../../ducks/cambiosDuck"
import { useState } from "react"
import BackDrop from "./../../../global/BackDrop"
import { StringItemsType } from "../../../constant/StringItemsType"
export const VCambioPasajerosStyle = makeStyles((theme) => ({
    root: {
        margin: "10px 0",
    },
    content: {
        margin: "20px 0",
    },
    contentButton: {
        margin: "20px 0",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    table: {
        minWidth: 650,
    },
}))
const validarSalida = ({ listaItems }) => {
    return listaItems.some(item => item.type === StringItemsType.SALIDA);
}

const CambioPaquete = () => {
    const classes = VCambioPasajerosStyle()
    const dispatch = useDispatch()
    const { referencia } = useSelector(store => store.cambios)
    const { listaItems, montoTotal, penalizacion, cantidadMensualidad, paquete, clavePaquete } = useSelector(store => store.cambiosPaquete)
    const [load, setLoad] = useState(false)
    const handleDeleteItem = (idItem) => {
        let arraItems = listaItems.filter(item => item.id !== idItem)
        dispatch(resetPenalizacionAction())
        dispatch(addItemsAction({ listaItem: arraItems }))
    }
    const handleClickPenality = () => {
        if (clavePaquete === "0") {
            ToastMessage.fire({
                icon: "info",
                title: "Seleccione un paquete",
            })
            return null
        }
        setLoad(true)
        dispatch(obtenerPenalizacionAction()).then(Response => {
            setLoad(false)
            if (Response.status === 500) {
                ToastMessage.fire({
                    icon: "error",
                    title: "Ha habido un problema intentar mas tarde",
                });
                return null;
            }
            if (Response.status === 400) {
                ToastMessage.fire({
                    icon: "warning",
                    title: Response.Message,
                });
                return null;
            }
        })
    }
    const handleClickGuardar = () => {
        DialogMessage.fire({
            title: '¿Estas seguro de aplicar este cambio?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aplicar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                setLoad(true)
                dispatch(aplicarCambioPaqueteAction()).then(Response => {
                    setLoad(false)
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        });
                        return null;
                    }
                    dispatch(resetPenalizacionAction())
                    dispatch(addItemsAction({ listaItem: [] }))
                    dispatch(obtnerViajeRefenciaAction())
                    dispatch(obtenerCotizacionAction({Referencia: referencia }))
                    dispatch(accionTargetAction({ accion: 0 }))            
                    ToastMessage.fire(
                        '¡Se aplico el cambio de paquete!',
                        '',
                        'success'
                    )
                })
            }
        })
    }
    return (
        <div className={classes.root}>
            <FCotizacion />
            <div>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="center">Item</TableCell>
                                <TableCell align="center">Monto unitario</TableCell>
                                <TableCell align="center">Cantidad</TableCell>
                                <TableCell align="center">Monto</TableCell>
                                <TableCell align="center">Moneda</TableCell>
                                <TableCell align="center">Acción</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                listaItems.map((item, index) => {
                                    return (
                                        <TableRow key={item.id}>
                                            <TableCell align="center">{`${item.type} - ${item.name}`}</TableCell>
                                            <TableCell align="center">{formatDinero(item.price)}</TableCell>
                                            <TableCell align="center">{item.quantity}</TableCell>
                                            <TableCell align="center">{formatDinero(item.price * item.quantity)}</TableCell>
                                            <TableCell align="center">{item.currency}</TableCell>
                                            <TableCell align="center">
                                                {
                                                    (item.type !== "PAQUETE") &&
                                                    <IconButton onClick={() => { handleDeleteItem(item.id) }}>
                                                        <HighlightOffIcon />
                                                    </IconButton>
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
                <div className={classes.content}>
                    <Typography variant="h6">
                        Total: {formatDinero(montoTotal)} {paquete?.Moneda?.Clave}
                    </Typography>
                    <Typography variant="h6">
                        Monto penalizacion: {formatDinero(penalizacion.MontoPenalizacion)} {paquete?.Moneda?.Clave}
                    </Typography>
                    <Typography variant="h6">
                        Total a cobrar por el cambio de Paquete: {formatDinero(penalizacion.MontoPaquete)} {paquete?.Moneda?.Clave}
                    </Typography>
                    <Typography variant="h6">
                        Monto mensual a cobrar con penalizcion: {formatDinero(penalizacion.MontoPaquete / cantidadMensualidad)} {paquete?.Moneda?.Clave}
                    </Typography>
                </div>
            </div>
            <div className={classes.contentButton}>
                {
                    (penalizacion.MontoPaquete > 0) ?
                        <Button onClick={handleClickGuardar} variant="contained" color="primary" disabled={!validarSalida({listaItems})}>
                            Aplicar Cambio
                        </Button>
                        :
                        <Button onClick={handleClickPenality} variant="contained" color="primary" disabled={!validarSalida({listaItems})}>
                            Calcular penalizaion
                        </Button>
                }
            </div>
            <BackDrop open={load} />
        </div>
    )
}
export default CambioPaquete